import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';

import LoadingSpinner from 'components/shared/LoadingSpinner';
import routes from './routes';

const Routes = () => (
  <Suspense fallback={<LoadingSpinner />}>
    <Switch>
      {routes.map((route, i) => (
        <RouteWithSubRoutes key={`${i}_${route.path}`} {...route} />
      ))}
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  </Suspense>
);

export default Routes;
